var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-test-page"},[(_vm.pdfUrl)?_c('PdfViewer',{attrs:{"pdf-url":_vm.pdfUrl,"show-toolbar":true,"initial-scale":1,"download-file-name":_vm.fileName || 'document.pdf'},on:{"loading-progress":_vm.onLoadingProgress,"pdf-loaded":_vm.onPdfLoaded}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }